import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { EMPLOYEES_ROUTES } from "./const";

@Component({
    selector: "app-employees",
    templateUrl: "./employees.component.html",
    styleUrls: ["./employees.component.css"],
    standalone: false
})
export class EmployeesComponent {

  // #region Propiedades del componente
  routes: object[] = [];
  // #endregion

  constructor(private router: Router) {
    this.routes = EMPLOYEES_ROUTES;
  }
}
